import classes from './TrashIcon.module.css';

interface ITrashIconProps {
    width?: number | string;
    height?: number | string;
    fill?: string;
}

const TrashIcon: React.FC<ITrashIconProps> = ({ width, height = 24 }) => {
    return <img src={`/icons/new/delete.svg`} alt="" aria-hidden="true" className={classes.icon} draggable={false} style={{ height, width: width ?? 'auto' }} />;
};

export default TrashIcon;
